import { BlueshyftCode } from '../Account/components/Deposit/Blueshyft/BlueshyftCode';
import { PendingBlueshyftCodes } from '../Account/components/Deposit/Blueshyft/PendingBlueshyftCodes';
import { remoteJSON } from './remote';

// External / deferred deposit types (eft or bpay), compared to other payment types we cannot verify instantly the status
export const createExternalDeposit = async (data: {
	date: string;
	amount: number;
	deposit_request_type: 'EFT' | 'BPAY';
	promotion?: {
		id: string;
		client_id: number;
	};
}) => {
	// API expects amount in cents
	data.amount *= 100;
	const response = (await remoteJSON('/deposit/external/create', {
		method: 'POST',
		body: JSON.stringify(data),
	})) as ExternalDepositResponse;

	return response;
};

// can be used with a new or stored card
export const creditcardCreateDepositRequest = async (
	amount: number,
	card_id?: number, // if this param is not present it will create a new card
	promotion?: {
		id: string;
		client_id: number;
	}
) => {
	const response = (await remoteJSON('/deposit/fatzebra/create', {
		method: 'POST',
		body: JSON.stringify({ amount: amount * 100, promotion, card_id }),
	})) as CreditcardCreateResponse;

	return response;
};

// only when adding a new card: send transaction Id back to our backend after adding a new credit card
export const creditcardCreateConfirm = async (reference_number: string, fzExtra: unknown) => {
	const response = (await remoteJSON('/deposit/fatzebra', {
		method: 'POST',
		body: JSON.stringify({ reference_number, extra: fzExtra }),
	})) as APIResponse;

	return response;
};

// this is used when making a deposit with an existing card, fzExtra is the payload from fatzebra with the result for the 3DS check
export const creditcardDepositConfirm = async (
	amount: number,
	card_id: number,
	fzExtra: unknown,
	promotion?: {
		id: string;
		client_id: number;
	}
) => {
	const response = (await remoteJSON('/deposit/fatzebra/save', {
		method: 'POST',
		body: JSON.stringify({ amount: amount * 100, card_id, extra: fzExtra, promotion }),
	})) as CreditcardDepositResponse;

	return response;
};

export const generateBlueshyftCode = async (amount: number, selectedPromotion?: { id: string; client_id: number }) => {
	const response = await remoteJSON('/deposit/blueshyft/code', {
		method: 'POST',
		body: JSON.stringify({ amount: amount * 100, promotion: selectedPromotion }),
	});

	return response.data as BlueshyftCode;
};

export const pendingBlueshyftCodes = async () => {
	const response = await remoteJSON('/deposit/blueshyft/pending_code', {
		method: 'GET',
	});

	return response.data as PendingBlueshyftCodes[];
};

export const deleteBlueshyftCode = async (id: number) => {
	const response = await remoteJSON(`/deposit/blueshyft/pending_code/${id}`, {
		method: 'DELETE',
	});

	return response;
};

export const registerZeptoAccount = async () => {
	const response = await remoteJSON('/deposit/zepto/register', {
		method: 'POST',
	}) as PayIDResponse

	return response;
}